module.exports = __webpack_public_path__ + "img/foto-escritorio-4.57bf75ad.png";